import { clearPhone } from '@/services/string';
import BaseService from '@/services/base_service';

export default class ExameService extends BaseService {
    create(model, idPet) {
        return new Promise((resolve, reject) => {

            axios.post('/exames', model).then(response => {
                resolve(response);
            }).catch(e => {
                reject(this.getErrors(e));
            });
        });
    }

    list(params) {

        return new Promise((resolve, reject) => {
            axios.get('/exames', params).then(response => {
                resolve(response);
            }).catch(e => {
                reject(e);
            });
        });
    }

    delete(id) {
        return new Promise((resolve, reject) => {
            axios.delete('/exames/' + id).then(response => {
                resolve(response);
            }).catch(e => {
                reject(e);
            });
        });
    }

    get(id) {
        return new Promise((resolve, reject) => {
            axios.get('/exames/' + id).then(response => {
                resolve(response);
            }).catch(e => {
                reject(e);
            });
        });
    }

    update(model, id) {
        return new Promise((resolve, reject) => {
            axios.put('/exames/' + id, model).then(response => {
                resolve(response);
            }).catch(e => {
                reject(e);
            });
        });
    }

}



// WEBPACK FOOTER //
// ./src/services/exam.js